import { NodeModel } from '@minoru/react-dnd-treeview';
import { DisassociateCostCenterModel } from '../../models/disassociate/costCenters.model';
import { EmployeeNodeModel } from '../../models/groupedEmployee.model';
import {
    InterruptionModel,
    InterruptionsListModel,
} from '../../models/interruptions/interruptionList.model';
import {
    WorkshiftSchedulingModel,
    WorkshiftsListModel,
} from '../../models/workshifts/workshif-scheduling/workshiftSchedulingList.model';
import { getChildNodes, getDatesBetweenDates } from '../../utils';

type Props = {
    grid: any;
    treeEmployees: NodeModel[];
    startDate: string;
    endDate: string;
    interruptionList: InterruptionsListModel;
    workshiftShedulingList: WorkshiftsListModel;
    openDisassociatedCostCenterModal: (
        initDate: string,
        lastDate: string,
        employee: NodeModel[],
        listToDelete: DisassociateCostCenterModel[]
    ) => void;
    getInterruptionsList: (
        startDate: string,
        endDate: string,
        employeeID: string | number,
        interruptionList: InterruptionsListModel
    ) => InterruptionModel[];
    getWorkshiftScheduling: (
        date: string | number,
        employeeID: string | number,
        workshiftShedulingList: WorkshiftsListModel
    ) => WorkshiftSchedulingModel | undefined;
};

export const controllerDisassociatedCostCentersModal = ({
    grid,
    treeEmployees,
    startDate,
    endDate,
    interruptionList,
    workshiftShedulingList,
    openDisassociatedCostCenterModal,
    getInterruptionsList,
    getWorkshiftScheduling,
}: Props) => {
    let row1 = grid.selectedRanges[0].row;
    let row2 = grid.selectedRanges[0].row2;
    let col1 = grid.selectedRanges[0].col - 2;
    let col2 = grid.selectedRanges[0].col2 - 2;

    if (row1 > row2) {
        let aux = row1;
        row1 = row2;
        row2 = aux;
    }

    if (col1 > col2) {
        let aux = col1;
        col1 = col2;
        col2 = aux;
    }

    let initDate = getDatesBetweenDates(startDate, endDate)[col1];
    let lastDate = getDatesBetweenDates(startDate, endDate)[col2];

    let selectedEmployees = getChildNodes(treeEmployees).slice(row1, row2 + 1);
    let dates = getDatesBetweenDates(initDate, lastDate);

    let listToDelete: DisassociateCostCenterModel[] = [];

    for (let emp = 0; emp < selectedEmployees.length; emp++) {
        for (let date = 0; date < dates.length; date++) {
        workshiftShedulingList.schedulings.forEach((e) => {
            if (
                e.costCenters &&
                e.employeeId == selectedEmployees[emp]?.id
            ) {
                e.costCenters.forEach((cc: any) => {
                    const ccDisplayDate = cc.displayDate 
                            ? cc.displayDate.split('T')[0] 
                            : cc.startDate.split('T')[0];

                    if (dates[date] === ccDisplayDate) {
                        let item: DisassociateCostCenterModel = {
                            id: cc.id,
                            costCenter: cc,
                            date: cc.startDate.split('T')[0],
                            employeeID: e.employeeId,
                            employee: selectedEmployees[emp]?.text,
                        };
                        listToDelete.push(item);
                    }
                });
            }
        });
        }
    }

    if (
        initDate &&
        lastDate &&
        selectedEmployees.length > 0 &&
        listToDelete.length > 0
    ) {
        openDisassociatedCostCenterModal(
            initDate,
            lastDate,
            selectedEmployees,
            listToDelete
        );
    }
};
